import { useState } from 'react'

import ChatIcon from '@heroicons/react/outline/ChatIcon'
import DotsHorizontalIcon from '@heroicons/react/outline/DotsHorizontalIcon'
import PencilIcon from '@heroicons/react/outline/PencilIcon'
import { Link as RouterLink } from 'react-router-dom'

import { hasScopesPermission } from '@tribeplatform/gql-client/lib'
import { Member } from '@tribeplatform/gql-client/types'
import { useAuthToken } from '@tribeplatform/react-sdk/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Dropdown } from '@tribeplatform/react-ui-kit/Dropdown'

import { generateNewChatPath } from '../../utils/messaging.utils'
import { ProfileSettingsModal } from '../Settings/ProfileSettingsModal'
import { MemberActionItems } from './MemberActionItems'

export const MemberActionButtons = ({ member }: { member: Member }) => {
  const [editModal, setEditModal] = useState(false)
  const {
    data: { member: authMember },
  } = useAuthToken()
  const [canUpdateMember] = hasScopesPermission(member, ['updateMember'])

  return (
    <>
      <Dropdown placement="bottom-end">
        <Dropdown.ButtonMinimal as="div">
          <Button variant="outline" leadingIcon={<DotsHorizontalIcon />} />
        </Dropdown.ButtonMinimal>
        <MemberActionItems member={member} className="w-56" />
      </Dropdown>

      {canUpdateMember ? (
        <Button
          onClick={() => setEditModal(true)}
          variant="outline"
          className="flex-shrink-0"
          leadingIcon={<PencilIcon />}
        >
          Edit profile
        </Button>
      ) : null}
      {member?.authMemberProps?.canSendPrivateMessages &&
      member?.id !== authMember?.id ? (
        <Button
          variant="primary"
          as={RouterLink}
          to={generateNewChatPath(member)}
          className="flex-shrink-0"
          leadingIcon={<ChatIcon />}
        >
          Message
        </Button>
      ) : null}

      {editModal && (
        <ProfileSettingsModal
          open
          onClose={() => {
            setEditModal(false)
          }}
          member={member}
        />
      )}
    </>
  )
}
